import ConfirmationDialog from 'components/Common/ConfirmationDialog';
import React, { useCallback, useContext, useState } from 'react';
import { FlowBuilderContext } from './FlowBuilderContextProvider';
import { HDialogContent } from 'BaseComponents';
import { TextField } from '@mui/material';


const Content = ({
  description,
  setDescription,
}) => (
  <HDialogContent>
    <TextField
      fullWidth
      margin='normal'
      onChange={(e) => setDescription(e.target.value)}
      label='Version name (optional)'
      placeholder='E.g., "Fixed filtering", "Added new node"'
      type='text'
      value={description}
      variant='outlined'
    />
  </HDialogContent>
);

const FlowSaveAsNewVersionDialog = () => {
  const {
    saveAsNewVersionDialog,
    saveAsNewVersionLoading,
    handleUpdateFlowAndCreateNewVersion,
    handleSaveAsNewVersionDialogClose,
  } = useContext(FlowBuilderContext);
  const [versionDescription, setVersionDescription] = useState('');

  const handleOnConfirm = useCallback(() => {
    handleUpdateFlowAndCreateNewVersion(versionDescription);
  }, [handleUpdateFlowAndCreateNewVersion, versionDescription]);

  return (
    <ConfirmationDialog
      open={saveAsNewVersionDialog.open}
      title='Name your new version'
      loading={saveAsNewVersionLoading}
      onCancel={() => handleSaveAsNewVersionDialogClose()}
      confirmActionLabel='Save Version'
      onConfirm={() => handleOnConfirm()}
      slots={{
        content: (
          <Content
            description={versionDescription}
            setDescription={setVersionDescription}
          />
        ),
      }}
    />
  );
};


export default FlowSaveAsNewVersionDialog;
